var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var EmitStatement = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat(['emit ', path.call(_print, 'eventCall'), ';']);
  }
};
module.exports = EmitStatement;